import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { HeaderDesktopComponent } from './header-desktop/header-desktop.component';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';
import { SharedModule } from '../../shared.module';
import { NotificationsDropdownComponent } from './header-desktop/components/notifications-dropdown/notifications-dropdown.component';
import { NotificationContentComponent } from './header-desktop/components/notifications-dropdown/notification-content/notification-content.component';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderDesktopComponent,
    HeaderMobileComponent,
    NotificationsDropdownComponent,
    NotificationContentComponent,
  ],
  exports: [HeaderComponent],
  imports: [SharedModule],
})
export class HeaderModule {}
